{
  "activity.action.reauthenticated": "Yakın kimlik doğrulaması yenilendi",
  "auth.confirmPassword": "Parolayı doğrula",
  "auth.resetRequestFailed": "Sıfırlama isteği gönderilemedi. Tekrar dene.",
  "auth.validation.confirmRequired": "Parolanı tekrar gir.",
  "auth.validation.displayNameMax": "En fazla {{count}} karakter kullan.",
  "auth.validation.emailInvalid": "Geçerli bir e-posta adresi gir.",
  "auth.validation.emailRequired": "E-posta adresini gir.",
  "auth.validation.mfaCode": "Altı haneli doğrulayıcı kodunu veya on karakterli kurtarma kodunu gir.",
  "auth.validation.passwordMax": "En fazla {{count}} karakter kullan.",
  "auth.validation.passwordMin": "En az {{count}} karakter kullan.",
  "auth.validation.passwordMismatch": "Parolalar eşleşmiyor.",
  "auth.validation.passwordRequired": "Parolanı gir.",
  "onboarding.assistant.connected": "Zaten bağlı",
  "onboarding.assistant.connected.hint": "Yapay zekâ bağlantının hazır olduğunu kaydet.",
  "onboarding.assistant.later": "Daha sonra bağla",
  "onboarding.assistant.later.hint": "Kurulumu şimdi bitir, ardından bağlantı ayarlarını aç.",
  "onboarding.assistant.skip": "Şimdi değil",
  "onboarding.assistant.skip.hint": "Exognitos'u yapay zekâ bağlantısı olmadan tam olarak kullan.",
  "onboarding.assistantChoice": "İsteğe bağlı yapay zekâ bağlantısı",
  "onboarding.bedtime": "Uyku saati",
  "onboarding.capture": "Hızlı Yakalama",
  "onboarding.captureHint": "Bir düşünceyi şimdi kaydet, ne anlama geldiğine sonra karar ver.",
  "onboarding.captureText": "Aklında ne var?",
  "onboarding.completeDescription": "Seçimlerin hesabına kaydedildi ve diğer oturumlarda da kullanılacak.",
  "onboarding.completeTitle": "Çalışma alanın hazır",
  "onboarding.conflict": "Bu kurulum başka bir oturumda ilerledi. Güncel adım yeniden yüklendi.",
  "onboarding.continue": "Devam et",
  "onboarding.dailyReminderTime": "Günlük planlama saati",
  "onboarding.dataAcknowledge": "Verilerimin ve bağlı hizmetlerin nasıl işlendiğini anlıyorum.",
  "onboarding.dataAcknowledgeHint": "Bağlantıları değiştirme, veriyi dışa aktarma ve hesabı silme seçenekleri Ayarlar'da kalır.",
  "onboarding.dataAssistant": "Bir yapay zekâ bağlantısı yalnızca açıkça verdiğin yeteneklere ve veri erişimine ulaşır.",
  "onboarding.dataControl": "Ayarlar; bağlantılar, dışa aktarma ve hesap silme için görünür denetimler sunar.",
  "onboarding.dataStored": "Çalışma alanı içeriğin bu Exognitos sunucusunda hesabının altında saklanır.",
  "onboarding.dataTitle": "Verilerin senin denetiminde kalır",
  "onboarding.end": "Bitiş",
  "onboarding.enterApp": "Exognitos'a gir",
  "onboarding.eyebrow": "Hesap kurulumu",
  "onboarding.finish": "Kurulumu bitir",
  "onboarding.firstContentKind": "Gerçek bir şeyle başla",
  "onboarding.genericError": "Bu adım kaydedilemedi. Seçimlerin burada duruyor; tekrar dene.",
  "onboarding.loadError": "Kurulum yüklenemedi",
  "onboarding.loadErrorDescription": "Bağlantıyı kontrol edip tekrar dene. Tamamlanan adımlar zaten kayıtlı.",
  "onboarding.locale": "Arayüz dili",
  "onboarding.locale.en": "İngilizce",
  "onboarding.locale.tr": "Türkçe",
  "onboarding.openAssistantSettings": "Bağlantı ayarlarını aç",
  "onboarding.progress": "Kurulum ilerlemesi",
  "onboarding.progressStep": "{{total}} adımın {{current}}. adımı",
  "onboarding.project": "Proje",
  "onboarding.projectHint": "İlerletmek istediğin somut bir sonuç oluştur.",
  "onboarding.projectTitle": "İlk Projenin başlığı",
  "onboarding.reminder.both": "İkisi de",
  "onboarding.reminder.both.hint": "Günlük planlamayı ve haftalık değerlendirmeyi görünür tut.",
  "onboarding.reminder.daily": "Günlük planlama",
  "onboarding.reminder.daily.hint": "Günün odağını seçmek için bir hatırlatma al.",
  "onboarding.reminder.none": "Hatırlatma yok",
  "onboarding.reminder.none.hint": "Exognitos'u zamanlanmış bildirimler olmadan kullan.",
  "onboarding.reminder.review": "Haftalık değerlendirme",
  "onboarding.reminder.review.hint": "Hafta sonu sıfırlaması için bir hatırlatma al.",
  "onboarding.reminderChoice": "Hangi hatırlatmalar yardımcı olur?",
  "onboarding.reviewReminderTime": "Haftalık değerlendirme saati",
  "onboarding.sampleCreate": "Örnek Proje oluştur",
  "onboarding.sampleCreated": "Etiketli örnek Proje çalışma alanında. Kaldırmak onu geri yüklenebileceği Çöp Kutusu'na taşır.",
  "onboarding.sampleDescription": "Örnek veri kuruluma sessizce eklenmez. İncelemek için bir örnek istiyorsan yalnızca açıkça etiketli tek bir Proje oluştur.",
  "onboarding.sampleRemove": "Örneği Çöp Kutusu'na taşı",
  "onboarding.sampleTitle": "İsteğe bağlı örnek veri",
  "onboarding.savedAutomatically": "Tamamlanan her adım hesabına kaydedilir.",
  "onboarding.sleepEnabled": "Olağan uyku aralığımı göster",
  "onboarding.sleepHint": "Bu seçenek planlamada sakin saatleri gölgeler; sağlık veya tıbbi veri değildir.",
  "onboarding.sleepWindow": "Uyku aralığı",
  "onboarding.start": "Başlangıç",
  "onboarding.step.assistant.description": "Exognitos tek başına çalışır. Yapay zekâ bağlamak isteğe bağlıdır ve izin kapsamlarıyla sınırlı kalır.",
  "onboarding.step.assistant.title": "Yapay zekânın yerini seç",
  "onboarding.step.data.description": "Kurulumu bitirmeden önce neyin saklandığını ve nelerin dışarı çıkabileceğini bil.",
  "onboarding.step.data.title": "Veri denetimlerini anla",
  "onboarding.step.firstContent.description": "Çalışma alanının senin için önemli bir şeyle başlaması için gerçek bir Proje veya Yakalama oluştur.",
  "onboarding.step.firstContent.title": "İlk şeyi yerine koy",
  "onboarding.step.profile.description": "Bu hesap ayarları tarihleri, dili ve yerel saatleri her cihazda tutarlı tutar.",
  "onboarding.step.profile.title": "Kendi zamanında başla",
  "onboarding.step.reminders.description": "Yalnızca yardımcı olan bildirimleri seç. Bunları istediğin zaman Ayarlar'dan değiştirebilirsin.",
  "onboarding.step.reminders.title": "Exognitos'un ne zaman hatırlatacağını seç",
  "onboarding.step.schedule.description": "Planlamanın varsayım yapmak yerine gününü yansıtması için olağan sınırlarını tanımla.",
  "onboarding.step.schedule.title": "Gerçekçi bir gün şekillendir",
  "onboarding.timezone": "IANA saat dilimi",
  "onboarding.validation.dataAck": "Bitirmek için veri açıklamasını okuyup onayla.",
  "onboarding.validation.firstContent": "İlk öğeni oluşturmak için bir başlık veya düşünce gir.",
  "onboarding.validation.sleepWindow": "Uyku ve uyanma için farklı saatler seç.",
  "onboarding.validation.timezone": "Europe/Istanbul gibi geçerli bir IANA saat dilimi gir.",
  "onboarding.validation.workWindow": "Çalışma için farklı başlangıç ve bitiş saatleri seç.",
  "onboarding.wake": "Uyanma saati",
  "onboarding.workWindow": "Olağan çalışma aralığı",
  "security.reauth.cancel": "Vazgeç",
  "security.reauth.code": "Doğrulayıcı veya kurtarma kodu",
  "security.reauth.codeHint": "Kurtarma kodunu ayıracıyla birlikte yapıştırabilirsin.",
  "security.reauth.description": "Hassas bir güvenlik ayarını değiştirmeden önce güncel kimlik bilgilerini doğrula.",
  "security.reauth.error": "Kimlik bilgilerin doğrulanamadı.",
  "security.reauth.password": "Geçerli parola",
  "security.reauth.title": "Sen olduğunu doğrula",
  "security.reauth.verify": "Doğrula ve devam et",
  "security.sessions.current": "Bu cihaz",
  "security.sessions.description": "Etkin tarayıcı oturumlarını incele ve artık tanımadığın bir cihazın oturumunu kapat.",
  "security.sessions.loadError": "Oturumlar yüklenemedi",
  "security.sessions.revoke": "Oturumu kapat",
  "security.sessions.revokeError": "Oturum kapatılamadı.",
  "security.sessions.title": "Oturum açılmış cihazlar",
  "security.sessions.unknownDevice": "Bilinmeyen tarayıcı",
  "security.sessions.unknownNetwork": "Ağ bilgisi yok"
}
